/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ limit: NonNullable<unknown> }} Assistant_Limit_ReachedInputs */



/**
* | output |
* | --- |
* | "You have reached today's limit of {limit} messages. The limit resets at 00:00 UTC." |
*
* @param {Assistant_Limit_ReachedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_limit_reached = /** @type {((inputs: Assistant_Limit_ReachedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Limit_ReachedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Vous avez atteint la limite de messages ${i?.limit} pour aujourd'hui. Cette limite sera réinitialisée à 00h00 UTC.`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Sie haben das heutige Limit von ${i?.limit}-Nachrichten erreicht. Das Limit wird um 00:00 UTC zurückgesetzt.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Hai raggiunto il limite odierno di messaggi ${i?.limit}. Il limite si azzera alle 00:00 UTC.`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Вы достигли сегодняшнего лимита в ${i?.limit} сообщений. Лимит обнуляется в 00:00 UTC.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Has alcanzado el límite de mensajes ${i?.limit} para hoy. El límite se restablece a las 00:00 UTC.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`您今天已达到${i?.limit}消息的发送上限。上限将于UTC时间00:00重置。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`本日の${i?.limit}メッセージ送信上限に達しました。上限はUTC 00:00にリセットされます。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`आपने आज ${i?.limit} संदेशों की सीमा पूरी कर ली है। यह सीमा 00:00 UTC पर रीसेट हो जाएगी।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Você atingiu o limite de mensagens ${i?.limit} para hoje. O limite será redefinido às 00:00 UTC.`)
	return /** @type {LocalizedString} */ (`You have reached today's limit of ${i?.limit} messages. The limit resets at 00:00 UTC.`)
});